import React from "react";

export const TextField = ({ question, value, onChange, lang }) => (
  <input
    type="text"
    className="dq-input"
    placeholder={
      lang === "ar" ? question.placeholder_arabic || "" : question.placeholder || ""
    }
    value={value || ""}
    onChange={(e) => onChange(e.target.value)}
    dir={lang === "ar" ? "rtl" : "ltr"}
  />
);
